import React, {useState} from 'react';
import {getUserFriendlyErrorMessage} from '@/utils/errorHandling.ts';
import {
  Button,
  ButtonVariant,
  Label,
  useModal,
  useToast
} from '@fs/uikit-react';
import styles from './SettingModalDelete.module.css';
import {Setting, SettingsApi} from '../../../SettingsApi.ts';

interface DeleteSettingModalProps {
  setting: Setting;
  onSuccess: () => void;
}

const SettingModalDelete: React.FC<DeleteSettingModalProps> = ({ setting, onSuccess }) => {
  const { closeModal } = useModal();
  const toast = useToast();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);

    try {
      await SettingsApi.delete(setting.id);

      toast.showSuccessToast('Success', 'Setting deleted successfully');

      closeModal();
      onSuccess();
    } catch (error) {
      console.error('Error deleting setting:', error);
      toast.showErrorToast(
        'Error deleting setting',
        getUserFriendlyErrorMessage(error)
      );
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className={styles.modalContent}>
      <Label
        text={`Ви впевнені, що хочете видалити налаштування \"${setting.key}\"?
         Повернути його назад в каталог буде неможливо.`}
      />

      <div className={styles.buttonGroup}>
        <Button
          variant={ButtonVariant.DESTRUCTIVE}
          title={isDeleting ? 'Видалення...' : 'Видалити'}
          onClick={handleDelete}
          disabled={isDeleting}
        />
        <Button
          variant={ButtonVariant.SECONDARY}
          title="Скасувати"
          onClick={closeModal}
        />
      </div>
    </div>
  );
};

export default SettingModalDelete;
